import { MenuItem } from '@carboncopyco/ui';
import { Combobox } from '@headlessui/react';

type FreeformTextOptionProps = {
  value: string;
  disabled: boolean;
};

export const FreeformTextOption = ({
  value,
  disabled,
}: FreeformTextOptionProps) => {
  return (
    <Combobox.Option
      className="p-1 shrink-0"
      value={{ id: null, name: value }}
    >
      {({ active }) => (
        <MenuItem
          disabled={disabled}
          focus={active}
          item={{
            id: 'freeformString',
            label: `"${value}"`,
          }}
        />
      )}
    </Combobox.Option>
  );
};
